import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Redirect, useParams } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import { useActiveBuyersForClient } from 'hooks';
import Loading from 'components/Loading';
import { AppContext } from 'context';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { UserRole } from 'types';
import CreateButton from 'components/Buttons/CreateButton';
import { Routes } from 'routes';
import { CollapsableContentContainer } from './CollapsableContentContainer';

const useStyles = makeStyles({
  buyersList: {
    maxWidth: '90%',
    margin: '2em 0 36px 0',
    padding: '0 0 2em 0',
    textAlign: 'left',
  },
});

const ClientBuyerContracts: React.FC = () => {
  const classes = useStyles();
  const { clientId } = useParams<{ clientId: string }>();
  const context = useContext(AppContext);
  const sortingCenter = context.getSortingCenter?.();
  const { value: buyers } = useActiveBuyersForClient(transformObjectId(sortingCenter), Number(clientId));
  const { t } = useTranslation('translation', { keyPrefix: 'clients' });

  // Check allowed:
  const roles = context.getRoles?.();
  const allowedCreate =
    sortingCenter?.isActive && roles && (roles.includes(UserRole.ROLE_MANAGER) || context.hasLeastOneAdminRole());
  const allowedUpdate =
    sortingCenter?.isActive && roles && (roles.includes(UserRole.ROLE_MANAGER) || context.hasLeastOneAdminRole());
  const [isEditing, setEditing] = useState(false);
  if (isEditing) {
    // Will be replace by internal form
    return <Redirect to={generatePath(Routes.ClientContracts, { clientId })} />;
  }

  return (
    <Box className={classes.buyersList}>
      {buyers ? (
        buyers.map(buyer => {
          return <CollapsableContentContainer clientId={clientId} buyer={buyer} canUpdate={allowedUpdate} />;
        })
      ) : (
        <Loading />
      )}
      {allowedCreate && (
        <CreateButton
          disabled={isEditing}
          onClick={() => {
            setEditing(true);
          }}
          icon={null}
          label={t('pageContent.createClientBuyerButtonLabel')}
        />
      )}
    </Box>
  );
};
export default ClientBuyerContracts;
